<!--
  The glyph is shown whole and the family is named right beside it: the word glosses the icon, so
  the iconography teaches itself tile by tile. Only the drawing is decorative — the family name is
  read out, as it was when it sat under the term.
-->
<ul class="character-tiles">
    @for (tag of visible(); track tag.code) {
        <li class="character-tile" [class.tile-lead]="tag.lead" [attr.data-group]="tag.iconKey">
            <span class="tile-top">
                <span class="tile-mark" aria-hidden="true">
                    <app-group-icon [group]="tag.iconKey" [size]="tag.lead ? 54 : 40"></app-group-icon>
                </span>
                @if (tag.groupName) {
                    <i class="tile-group">{{ tag.groupName }}</i>
                }
            </span>

            <span class="tile-body">
                <b class="tile-term">{{ tag.label }}</b>
            </span>
        </li>
    }
</ul>
